export default "__VITE_ASSET__OcmEXWiy__"